if (!customElements.get("header-drawer-toggle")) {
  customElements.define(
    "header-drawer-toggle",
    class HeaderDrawerToggle extends HTMLElement {
      constructor() {
        super();

        this.headerOpenButton = this.querySelector(".js-header-open");
        this.headerCloseButtons = this.querySelectorAll(".js-header-close");
        this.navigationArea = this.querySelector(".js-header-navArea");
        this.registerBtn = this.querySelector(".js-register");
      }

      connectedCallback() {
        this.navigationArea.style.opacity = "0";

        this.headerOpenButton.addEventListener(
          "click",
          this.initOpen.bind(this)
        );
        this.headerCloseButtons.forEach((headerCloseButton) => {
          headerCloseButton.addEventListener(
            "click",
            this.initClose.bind(this)
          );
        });

        if (this.registerBtn) {
          this.registerBtn.addEventListener("click", this.register.bind(this));
        }
      }

      getScrollbarWidth() {
        // Creating invisible container
        const outer = document.createElement("div");
        outer.style.visibility = "hidden";
        outer.style.overflow = "scroll"; // forcing scrollbar to appear
        outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
        document.body.appendChild(outer);

        // Creating inner element and placing it in the container
        const inner = document.createElement("div");
        outer.appendChild(inner);

        // Calculating difference between container's full width and the child width
        const scrollbarWidth = outer.offsetHeight;

        // Removing temporary element from the DOM
        outer.parentNode.removeChild(outer);

        return scrollbarWidth;
      }

      initOpen() {
        this.parentNode.classList.add("is-active");
        document.body.style.overflowY = "hidden";
        document.body.style.paddingRight = this.getScrollbarWidth() + "px";

        const header = document.querySelector("header.header");
        const headerBottom = header.getBoundingClientRect().bottom;

        this.parentNode.style.setProperty("--header-openarea-top", headerBottom + "px");
      }

      initClose() {
        this.parentNode.classList.remove("is-active");
        document.body.style.overflowY = "visible";
        document.body.style.paddingRight = 0;
      }

      register(e) {
        this.initClose();
      }
    }
  );
}
